import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubIssue } from '../types/hubissue';
import { IssueActionType } from '../types/issue-action-type';
import { IssuePriority } from '../types/issue-priority';
import { IssueSource } from '../types/issue-source';
import { IssueStatus } from '../types/issue-status';
import { IssueTag } from '../types/issue-tag';
import { IssueTagAction } from '../types/issue-tag-action';
import { IssueTagType } from '../types/issue-tag-type';

@Component({
  selector: 'new-issue',
  templateUrl: './new-issue.component.html',
  styleUrls: ['./new-issue.component.css'],
  providers: [HubService],
})

export class NewIssueComponent implements OnInit, OnChanges {
  @Input() inHub: Hub;
  @Input() issue_sources = <IssueSource[]>[];
  @Input() issue_statuses = <IssueStatus[]>[];
  @Input() issue_priorities = <IssuePriority[]>[];
  @Input() action_types = <IssueActionType[]>[];
  @Output() issue_saved = new EventEmitter<boolean>();

  @Input() issueTagList = <IssueTag[]>[];
  @Input() issueTagActionList = <IssueTagAction[]>[];
  @Input() newIssueTag = new IssueTag();
  issueTagTypeList = <IssueTagType[]>[];

  hub: Hub;
  issue = new HubIssue();
  errorMessage: string;

  
  

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    this.hubService.getLookupTable('issue_tag').subscribe(
      lookup_values => this.issueTagList = <IssueTag[]>lookup_values,
      error => this.errorMessage = <any>error,
    );
    this.hubService.getLookupTable('issue_action').subscribe(
      lookup_values => this.issueTagActionList = <IssueTagAction[]>lookup_values,
      error => this.errorMessage = <any>error,
    );
    this.hubService.getLookupTable('issue_tag_type').subscribe(
      lookup_values => this.issueTagTypeList = <IssueTagType[]>lookup_values,
      error => this.errorMessage = <any>error,
    );

    this.switchHub();
  }

  switchHub(): void {
    if (!this.inHub) {
      this.hub = new Hub();
    } else {
      this.hub = Object.assign({}, this.inHub);  // Clone
      this.issue.hubid = this.hub.hubid;
    }

    this.issue.status = 1;
    this.issue.priority = 4;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName of Object.keys(changes)) {
      // console.log('Property ' + propName + ' changed');
      switch (propName) {
        case 'inHub':
          this.switchHub();
          break;
      }
    }
  }

  // isValid() is called from the HTML on changes
  isValid(): boolean {
    if (!this.issue) {
      this.errorMessage = `Something went wrong internally!`;
      return false;
    }
    if (!this.issue.hubid) {
      this.errorMessage = `Each issue must be associated with a HubID`;
      return false;
    }
    if (!this.issue.source) {
      this.errorMessage = `You must select a source for the issue.`;
      return false;
    }
    if (!this.issue.status) {
      this.errorMessage = `You must select a status for the issue.`;
    }
    if (!this.issue.title || this.issue.title.length < 10) {
      this.errorMessage = `Every issue must have a title of at least 10 characters. Preferably more.`;
      return false;
    }
    // if (!this.issue.description) { return false;}
    // if (this.issue.description.length < 5) { return false;}
    this.errorMessage = '';
    return true;
  }

  cancel(): void {
   this.issue_saved.emit(false);
  }

  save(): void {
    if (!!this.hub && !this.issue.hubid) {
      this.issue.hubid = this.hub.hubid;
    }
    if (!this.issue.user_profile_id) {
      this.issue.user_profile_id = `${AppComponent.GetUserProfile().id}`;
      this.issue.user_profile_type = Number(AppComponent.GetUserProfile().type);
    }
    if (!this.issue.status || this.issue.status < 1) { this.issue.status = 1; }
    if (!this.issue.source || this.issue.source < 1) { this.issue.source = 1; }
    this.issue.priority = Number(this.issue.priority);
    console.log("Saving.....")
    console.log(this.issue);
    this.hubService.writeIssue(this.issue)
      .subscribe(() => this.issue_saved.emit(true));
  }

  reset(){
    console.log("Reseting............");
    this.issue.issue_tag_id = null;
  }

}
